import axios from "axios";
import authHeader from '../../../authheader'

const PLSAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualPlsApplication";



const getBoardRecommendations = (applicationId) => {
    return axios.get(`${PLSAPPLICATIONURL}/boardrecommendations`, { headers: authHeader(), params: { applicationId } });
}
const getBoardResponses = (applicationId) => {
    return axios.get(`${PLSAPPLICATIONURL}/boardmemberresponses`, { headers: authHeader(), params: { applicationId } });
}
const postBoardRecommendation = (data) => {
    return axios.post(`${PLSAPPLICATIONURL}/boardrecommendation`, data, { headers: authHeader() });
}
const postBoardResponse = (data) => {
    var header = authHeader();
    header['Content-Type'] = 'multipart/form-data';
    return axios.post(`${PLSAPPLICATIONURL}/boardmemberresponse`, data, { headers: { ...header } });
}
export default {
    getBoardRecommendations,
    getBoardResponses,
    postBoardRecommendation,
    postBoardResponse
}